<ng-container>
    <div #parent id="left-side-bar" class="leftSidebar">
        @if ((flowState$ | async) !== 'SEARCH_MODE') {
            <div id="left-drag-bar" class="left-drag-bar" appResize [parent]="parent" left-to-right></div>
        }
        <mat-accordion id="leftSidebarContent" class="leftSidebarContent" [multi]="multi">
            <mat-expansion-panel appCustomMatExpansionToggle class="leftSidebar_dropdown" [expanded]="configPanelExpanded">
                <mat-expansion-panel-header [@.disabled]="true" expandedHeight="45px">
                    <mat-panel-title> Configuration </mat-panel-title>
                </mat-expansion-panel-header>
                <ul class="leftSidebar_list">
                    <li class="leftSidebar_items" (click)="route('/keywords')"
                        [ngClass]="router.url === '/keywords' ? 'leftSidebar_items_selected' : ''">
                        Keywords
                    </li>
                    @if (sharedService.getEntityType() !== 'TEMPLATE') {
                        <li class="leftSidebar_items" (click)="route('/routing')"
                            [ngClass]="router.url === '/routing' ? 'leftSidebar_items_selected' : ''">
                            Routing
                        </li>
                        <li class="leftSidebar_items" (click)="route('/apiIntegration')"
                            [ngClass]="router.url === '/apiIntegration' ? 'leftSidebar_items_selected' : ''">
                            API Integration
                        </li>
                    }
                    @if (isUserInternal || isClientAdmin) {
                        <li class="leftSidebar_items" (click)="route('/settings')"
                            [ngClass]="router.url === '/settings' ? 'leftSidebar_items_selected' : ''">
                            Settings
                        </li>
                    }
                    <li class="leftSidebar_items" (click)="route('/assets-library')"
                        [ngClass]="router.url === '/assets-library' ? 'leftSidebar_items_selected' : ''">
                        Asset Library
                    </li>
                    <li class="leftSidebar_items" id="leftSideBarAnalyticsSettings"
                        (click)="route('/analytics-settings')"
                        [ngClass]="router.url === '/analytics-settings' ? 'leftSidebar_items_selected' : ''">
                        Analytics Settings
                    </li>
                </ul>
            </mat-expansion-panel>
            <mat-expansion-panel #flowsPanel appCustomMatExpansionToggle class="leftSidebar_dropdown leftSidebar_dropdown_flows"
                                 [expanded]="flowsPanelExpanded" (opened)="onPanelOpened()" (closed)="onPanelClosed()">
                <mat-expansion-panel-header [@.disabled]="true" expandedHeight="45px">
                    <mat-panel-title> {{ sharedService.getEntityType()!=='TEMPLATE'? 'Flows' : 'Template' }}
                    </mat-panel-title>

                    <div class="leftSidebar_manage_create">

                        <ng-container [ngTemplateOutlet]="addNewFlow"></ng-container>

                        <div class="leftSidebar_btn" matTooltipClass="matTooltip"
                             matTooltip="{{sharedService.getEntityType()!=='TEMPLATE'? 'Manage flows':'Manage templates'}}"
                             matTooltipPosition="above" (click)="$event.stopPropagation(); flowManagement($event)">
                            <div class="leftSidebar_manage_btn">
                                <div [ngClass]="{ management_Notifications: hasNotification() }"></div>
                            </div>
                        </div>

                    </div>
                </mat-expansion-panel-header>
                <div id="leftSidebarFlow" class="tree-content">
                    <div class="leftSidebar_createFlowBox">
                        <input class="searchBtn" placeholder="Search..." #searchFor value=""
                           (input)="searchForChange(searchFor)" />
                        @if (searchFor.value) {
                            <div mat-button matSuffix mat-icon-button aria-label="Clear"
                                 (click)="searchFor.value = ''; searchForValue = ''" class="searchDiv_searchDelete"></div>
                        }
                    </div>
                    <clickatell-tree (onFileClick)="flowClicked($event)" [treeData$]="flowManagerService.flowsCache$"
                         [lockedFlows]="flowWebSocket.getLockFlows" [searchValue]="searchForValue" [disableFlowFilter]="true">
                    </clickatell-tree>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </div>
</ng-container>

<ng-template #addNewFlow>
    @if (globalEnvironment.entityType !== 'VENDOR' && globalEnvironment.entityType !== 'FUNDING_SOURCE') {
        @if (globalEnvironment.environment != 'prod' && userCanEditFlow()) {
            <div class="leftSidebar_btn" matTooltipClass="matTooltip"
                 matTooltip="Create new {{globalEnvironment.entityType!=='TEMPLATE'?'flow':'template'}}"
                 matTooltipPosition="above"
                 [matMenuTriggerFor]="flowTypeMenu" (click)="$event.stopPropagation()">
                <mat-menu #flowTypeMenu="matMenu">
                    <button class="add-new-flow-btn" mat-menu-item (click)="newFlowClick(FlowType.ChatFlow)">
                        <img class="add-btn-icon" src="assets/svg/redesign/flow-light.svg">
                        Standard Flow
                    </button>
                    <button class="add-new-flow-btn" mat-menu-item (click)="newFlowClick(FlowType.ApiFlow)">
                        <img class="add-btn-icon" src="assets/svg/redesign/api_flow-gray.svg">
                        Dynamic API Flow
                    </button>
                    <!--<button class="add-new-flow-btn" mat-menu-item (click)="newFlowClick(FlowType.ChatFlow, false, true);">
                        <img class="add-btn-icon" src="assets/svg/redesign/nodes.svg">
                        Template
                    </button>-->
                </mat-menu>
                <div class="leftSidebar_createFlow_btn"></div>
            </div>
        }
    } @else {
        @if (globalEnvironment.environment != 'prod' && userCanEditFlow()) {
            <div class="leftSidebar_btn" matTooltipClass="matTooltip"
                 matTooltip="Create new {{globalEnvironment.entityType!=='TEMPLATE'?'flow':'template'}}"
                 matTooltipPosition="above"
                 [matMenuTriggerFor]="apiEntityMenu" (click)="$event.stopPropagation()">
                <mat-menu #apiEntityMenu="matMenu">
                    <button class="add-new-flow-btn" mat-menu-item (click)="newFlowClick(FlowType.ChatFlow)">
                        <img class="add-btn-icon" src="assets/svg/redesign/flow-light.svg">
                        Standard Flow
                    </button>
                    <button class="add-new-flow-btn" mat-menu-item (click)="newFlowClick(FlowType.ApiFlow)">
                        <img class="add-btn-icon" src="assets/svg/redesign/api_flow-gray.svg">
                        Dynamic API Flow
                    </button>
                    <button class="add-new-flow-btn" mat-menu-item (click)="newFlowClick(FlowType.ChatFlow, false, true);">
                        <img class="add-btn-icon" src="assets/svg/redesign/nodes.svg">
                        Template
                    </button>
                </mat-menu>
                <div class="leftSidebar_createFlow_btn"></div>
            </div>
        }
    }
</ng-template>
